import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = { class: "form-header" }
const _hoisted_7 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_8 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_9 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_10 = { class: "form-body" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { for: "frm-userProfileForm_userName" }
const _hoisted_13 = {
  key: 0,
  class: "form-error"
}
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = { for: "frm-userProfileForm_email" }
const _hoisted_16 = {
  key: 0,
  class: "form-error"
}
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = { for: "frm-userProfileForm_phoneNumber" }
const _hoisted_19 = { class: "multiple-inputs" }
const _hoisted_20 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_21 = {
  key: 0,
  class: "form-error"
}
const _hoisted_22 = { class: "form-footer" }
const _hoisted_23 = { class: "buttons" }
const _hoisted_24 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('UserBasicProfileEdit.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", {
          id: "userProfile-form",
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('UserBasicProfileEdit.form-header')), 1)
          ]),
          (_ctx.showFormMessages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('UserBasicProfileEdit.success-message')), 1))
                  : _createCommentVNode("", true),
                (_ctx.isError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flashmessage flash-danger"
                  }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.lastName.$error }])
              }, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('UserBasicProfileEdit.lastName')) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "frm-userProfileForm_userName",
                  name: "userName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.lastName.$model) = $event)),
                  class: "form-control is-required"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.lastName.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.lastName.$dirty && _ctx.v$.form.lastName.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.lastName.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('UserBasicProfileEdit.email')) + ":", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  disabled: "",
                  id: "frm-userProfileForm_email",
                  name: "email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                  class: "form-control is-required"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.v$.form.email.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.email.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('forms.required')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('UserBasicProfileEdit.phoneNumber')) + ":", 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_PhonePrefix, {
                      id: "frm-userProfileForm_phoneNumberPrefix",
                      modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                    type: "text",
                    id: "frm-userProfileForm_phoneNumber",
                    placeholder: "900 000 000",
                    name: "phoneNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.phoneNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_ctx.v$.form.phoneNumber.$dirty && _ctx.v$.form.phoneNumber.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", _hoisted_24, _toDisplayString(_ctx.$t('UserBasicProfileEdit.button-save')), 1),
              _createVNode(_component_router_link, {
                to: { name: 'UserProfile' },
                tag: "button",
                class: "button button--primary reversed"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('UserBasicProfileEdit.button-cancel')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}